import React from 'react';
import { TCheckIconProps } from 'components/CheckIcon/CheckIcon.types';

const CheckIcon: React.FC<TCheckIconProps> = (props): React.ReactElement => {
	const {width, color} = props;
	return <svg width={width || 14} fill={color || '#000000'} viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">
		<g id="SVGRepo_bgCarrier" strokeWidth="0"/>
		<g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
		<g id="SVGRepo_iconCarrier">
			<path d="M1827.701 303.065 698.835 1431.801 92.299 825.266 0 917.564 698.835 1616.4 1919.869 395.234z"
						fillRule="evenodd"/>
		</g>
	</svg>;
};

export default CheckIcon;
